import axios from "axios"
import ElementUI from 'element-ui'
import store from "../../../store";

axios.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers.Authorization = store.getters.token
  }
  return config
}, error => {
  return Promise.reject(error.response);
})

axios.interceptors.response.use(res => {
    if (res.data.code === 200) {
      return Promise.resolve(res);
    } else if (res.data.code === 402) {
      // 退出登录
      store.dispatch('user/logout')
    } else if (res.status === 200 && (res.data.code === undefined)) {
      return Promise.resolve(res);
    } else {
      ElementUI.Message.error(res.data.msg);
      return Promise.reject(res);
    }
  },
  error => {
    ElementUI.Message.error(error.response.data.msg || error.response.statusText)
    return Promise.reject(error);
  }
);

export default axios;



// WEBPACK FOOTER //
// ./src/assets/js/httpConfig/http.js